<template>
  <!-- Filtrado de la tabla -->
  <div class="filtro-tabla" v-if="filtro">
    <b-row class="carga-archivos filtro">
      <b-col cols="12" align-self="center">
        <b-row>
          <b-col sm="12" md="12" lg="2">
            <h3>Filtrado</h3>
          </b-col>
          <b-col sm="12" md="12" lg="10">
            <b-row>
              <b-col sm="12" md="6" lg="3" v-if="showFilterDates">
                <b-form-group label="Desde:" label-for="desde">
                  <datepicker
                    v-model="dateInicio"
                    :language="es"
                    bootstrap-styling
                    :format="customFormatter"
                    name="desde"
                  ></datepicker>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterDates">
                <b-form-group label="Hasta:" label-for="hasta">
                  <datepicker
                    v-model="dateFin"
                    :language="es"
                    bootstrap-styling
                    :format="customFormatter"
                    name="hasta"
                  ></datepicker>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showSelectFiltro">
                <b-form-group label="Seleccione:" label-for="seleccione">
                  <SelectComponet
                    v-model="filterSelected"
                    :data="SetectFiltro"
                    name="seleccione"
                  ></SelectComponet>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterConvenios">
                <b-form-group label="Codigo:" label-for="convenios">
                  <SelectComponet
                    v-model="filterConvenioSelected"
                    :data="Convenios"
                    id="convenios"
                    :disabled="loading_helper"
                  ></SelectComponet>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterEstadoGarantia">
                <b-form-group label="Estados:" label-for="estadosGarangia">
                  <SelectComponet
                    v-model="filterEstadoGarantiaSelected"
                    :data="EstadoGarantia"
                    id="estadosGarangia"
                  ></SelectComponet>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterCedula">
                <b-form-group label="Cédula" label-for="cedula">
                  <b-form-input
                    id="cedula"
                    type="text"
                    v-model="filterCedula"
                    placeholder="Cédula"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterPagare">
                <b-form-group label="Pagaré" label-for="pagare">
                  <b-form-input
                    id="pagare"
                    type="text"
                    v-model="filterPagare"
                    placeholder="Pagaré"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterCaseNumber">
                <b-form-group label="Numero del caso" label-for="case_number">
                  <b-form-input
                    id="case_number"
                    type="number"
                    v-model="filterCaseNumber"
                    placeholder="Ej: 5444872"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterCaseName">
                <b-form-group label="Nombre del caso" label-for="case_name">
                  <b-form-input
                    id="case_name"
                    type="text"
                    v-model="filterCaseName"
                    placeholder="Ej: Petición Actualización"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterModelos">
                <b-form-group label="Modelo:" label-for="Modelos">
                  <SelectComponet
                    v-model="filterModelosSelected"
                    :data="Modelos"
                    id="Modelos"
                  ></SelectComponet>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="showFilterTipoDoc">
                <b-form-group label="Tipo de archivo:" label-for="Tipo de archivo">
                  <SelectComponet
                    v-model="filterTipoArchivoSelected"
                    :data="TipoArchivo"
                    id="TipoArchivo"
                  ></SelectComponet>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="6" lg="3" v-if="pagination">
                <b-form-group
                  label="Registros por pagina:"
                  label-for="inputGroupSelect01"
                >
                  <select
                    class="custom-select"
                    id="inputGroupSelect01"
                    v-model="nRows"
                    @change="setPages(nRows)"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </b-form-group>
              </b-col>

              <b-col sm="1" offset="10">
                <div class="filtro-button text-right">
                  <b-button v-if="showButtonBorrar"
                    variant="primary"
                    @click="clickBorrar()"
                    size="sm"
                    class="btn-filtro"
                    >Borrar</b-button
                  >
                  <b-button v-if="showButtonBuscar"
                    variant="primary"
                    @click="clickBuscar()"
                    size="sm"
                    class="btn-filtro"
                    :disabled="loading"
                    >Buscar</b-button
                  >
                  <b-button v-if="showButtonGenerar"
                    variant="primary"
                    @click="clickGenerar()"
                    size="m"
                    class="btn-filtro"
                    :disabled="loadGenerar || disableGenerar"
                    >Generar</b-button
                  >
                  <!-- <b-button v-if="showButtonGenerar"
                    variant="success"
                    @click="clickGenerarCompleto()"
                    size="sm"
                    class="btn-filtro w-150"
                    :disabled="loadGenerar || disableGenerar"
                    >Base Histórica</b-button
                  > -->
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import SelectComponet from "@/components/form/Select.vue";

export default {
  name: "FilterTable",
  data() {
    return {
      dateInicio: this.$moment().startOf("month").format("YYYY-MM-DD 00:00:00"),
      dateFin: this.$moment().format("YYYY-MM-DD 23:59:59"),
      filterSelected: null,
      filterCedula: null,
      filterPagare: null,
      filterCaseNumber: null,
      filterCaseName: null,
      filterEstadoGarantiaSelected: null,
      filterModelosSelected:null,
      filterTipoArchivoSelected:null,
      filterConvenioSelected: null,
      nRows: null,
      es: es,
      selected: null,
      pages: [],
    };
  },
  props: {
    SetectFiltro: {
      default: () => [],
      type: Array,
      required: false,
    },
    showButtonBuscar: {
      default: () => true,
      type: Boolean,
    },
    showButtonBorrar: {
      default: () => true,
      type: Boolean,
    },
    showButtonGenerar: {
      default: () => false,
      type: Boolean,
    },
    EstadoGarantia: {
      default: () => [],
      type: Array,
      required: false,
    },
    Modelos: {
      default: () => [],
      type: Array,
      required: false
    },
    TipoArchivo: {
      default: () => [],
      type: Array,
      required: false
    },
    Convenios: {
      default: () => [],
      type: Array,
      required: false,
    },
    showSelectFiltro: {
      default: () => true,
      type: Boolean,
    },
    showFilterDates: {
      default: () => false,
      type: Boolean,
    },
    showFilterCedula: {
      default: () => false,
      type: Boolean,
    },
    showFilterPagare: {
      default: () => false,
      type: Boolean,
    },
    showFilterCaseNumber: {
      default: () => false,
      type: Boolean,
    },
    showFilterCaseName: {
      default: () => false,
      type: Boolean,
    },
    showFilterConvenios: {
      default: () => false,
      type: Boolean,
    },
    showFilterEstadoGarantia: {
      default: () => false,
      type: Boolean,
    },
    showFilterModelos: {
      default: () => false,
      type: Boolean
    },
    showFilterTipoDoc: {
      default: () => false,
      type: Boolean
    },
    filtro: {
      default: () => false,
      type: Boolean,
    },
    pagination: {
      default: () => false,
      type: Boolean,
    },
    dataLength: {
      type: Number,
      required: true,
    },
    perPage: {
      default: () => null,
    },
    disableGenerar: {
      default: () => false,
      type: Boolean
    },
    loadGenerar: {
      default: () => false,
      type: Boolean
    },
    showButtonGenerarHistorico: {
      default: () => false,
      type: Boolean
    }
  },
  components: {
    SelectComponet,
    Datepicker,
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    loading_helper() {
      return this.$store.getters.loading_helper;
    },
  },
  methods: {
    customFormatter(date) {
      return this.$moment(date).format("YYYY-MM-DD");
    },
    clickBuscar() {
      this.$emit("buscar", {
        fecha_inicio: this.$moment(this.dateInicio).format(
          "YYYY-MM-DD 00:00:00"
        ),
        fecha_fin: this.$moment(this.dateFin).format("YYYY-MM-DD 23:59:59"),
        filterSelected: this.filterSelected,
        cedula: this.filterCedula,
        pagare: this.filterPagare,
        case_number: this.filterCaseNumber,
        nombre: this.filterCaseName,
        convenio: this.filterConvenioSelected,
        filterEstadoGarantiaSelected: this.filterEstadoGarantiaSelected,
        filterModelosSelected:this.filterModelosSelected,
        filterTipoArchivoSelected:this.filterTipoArchivoSelected,
        nRows:this.nRows
      });
    },
    clickGenerar() {
      this.$emit("generar", {
        fecha_inicio: this.$moment(this.dateInicio).format("YYYY-MM-DD"),
        fecha_fin: this.$moment(this.dateFin).format("YYYY-MM-DD"),
        filterSelected: this.filterSelected,
        cedula: this.filterCedula,
        pagare: this.filterPagare,
        case_number: this.filterCaseNumber,
        nombre: this.filterCaseName,
        convenio: this.filterConvenioSelected,
        filterEstadoGarantiaSelected: this.filterEstadoGarantiaSelected,
        filterModelosSelected:this.filterModelosSelected,
        filterTipoArchivoSelected:this.filterTipoArchivoSelected
      });
    },
    clickGenerarCompleto(){
      this.$emit("generarCompleto", {
        fecha_inicio: this.$moment(this.dateInicio).format("YYYY-MM-DD"),
        fecha_fin: this.$moment(this.dateFin).format("YYYY-MM-DD"),
        filterSelected: this.filterSelected,
        cedula: this.filterCedula,
        pagare: this.filterPagare,
        case_number: this.filterCaseNumber,
        nombre: this.filterCaseName,
        convenio: this.filterConvenioSelected,
        filterEstadoGarantiaSelected: this.filterEstadoGarantiaSelected,
        filterModelosSelected:this.filterModelosSelected,
        filterTipoArchivoSelected:this.filterTipoArchivoSelected
      });
    },
    clickBorrar() {
        (this.dateInicio = this.$moment().startOf("month").format("YYYY-MM-DD 00:00:00")),
        (this.dateFin = this.$moment().format("YYYY-MM-DD 23:59:59")),
        (this.filterSelected = null),
        (this.filterCedula = null),
        (this.filterPagare = null),
        (this.filterCaseNumber = null),
        (this.filterCaseName = null),
        (this.filterConvenioSelected = null),
        (this.filterEstadoGarantiaSelected = null),
        (this.filterModelosSelected = null);
        (this.filterTipoArchivoSelected = null);
    },
    setPages(nRows) {
      this.$emit("set-pages", nRows, true);
    },
  },
  watch: {
    selected: value => {},
    dateInicio(){
      this.$store.commit("table/setDateInicio",this.$moment(this.dateInicio).format('YYYY-MM-DD 00:00:00'));
    },
    dateFin(){
      this.$store.commit("table/setDateFin",this.$moment(this.dateFin).format('YYYY-MM-DD 00:00:00'));
    },
    filterSelected(){
      this.$store.commit("table/setFilterSelected",this.filterSelected);
    },
    filterConvenioSelected(){
      this.$store.commit("table/setFilterConvenioSelected",this.filterConvenioSelected);
    },
    filterEstadoGarantiaSelected(){
      this.$store.commit("table/setFilterEstadoGarantiaSelected",this.filterEstadoGarantiaSelected);
    },
    filterCedula(){
      this.$store.commit("table/setFilterCedula",this.filterCedula);
    },
    filterPagare(){
      this.$store.commit("table/setFilterPagare",this.filterPagare);
    },
    filterCaseNumber(){
      this.$store.commit("table/setFilterCaseNumber",this.filterCaseNumber);
    },
    filterCaseName(){
      this.$store.commit("table/setFilterCaseName",this.filterCaseName);
    },
    filterModelosSelected(){
      this.$store.commit("table/setFilterModelosSelected",this.filterModelosSelected);
    },
    filterTipoArchivoSelected(){
      this.$store.commit("table/filterTipoArchivoSelected",this.filterTipoArchivoSelected);
    },
    nRows(){
      this.$store.commit("table/setnRows",this.nRows);
    },
  },
  mounted() {
    this.nRows = this.perPage;
    this.$store.commit("table/setDateInicio",this.$moment(this.dateInicio).format('YYYY-MM-DD 00:00:00'));
    this.$store.commit("table/setDateFin",this.$moment(this.dateFin).format('YYYY-MM-DD 00:00:00'));
  }
};
</script>
